import DISPLAY from 'constants/display'
import { RELAY_PAYMENTS_NETWORK_STATUSES } from '../constants'

export const getRelayPaymentsNetworkStatusLabel = (networkStatus?: string | null) => {
  return (
    RELAY_PAYMENTS_NETWORK_STATUSES.find(ns => ns.value === networkStatus)?.label || DISPLAY.unknown
  )
}
